import { apiPath } from './api.path';
import { instance } from './axios';

async function getChaptersAPI(params) {
  return instance.get(`${apiPath.getChapters}/${params}`).then((response) => response.data);
}

// async function addChapterAPI(params) {
//   const bodyFormData = new FormData();
//   bodyFormData.append('parent', params.parent);
//   bodyFormData.append('name', params.name);
//   bodyFormData.append('subHeading', params.subHeading);
//   bodyFormData.append('content', params.content);
//   bodyFormData.append('type', params.type);
//   bodyFormData.append('subCategory', params.subCategory);
//   bodyFormData.append('subCategories', params.subCategories);
//   return instance.post(apiPath.addChapter, bodyFormData).then((response) => response.data);
// }
async function addChapterAPI(params) {
  const bodyFormData = new FormData();
  // bodyFormData.append('parent', params.parent);
  bodyFormData.append('name', params.name || ' ');
  bodyFormData.append('subHeading', params.subHeading || ' ');
  bodyFormData.append('content', params.content || ' ');
  bodyFormData.append('type', params.type);
  bodyFormData.append('subcategory', params.subCategory || '');
  bodyFormData.append('showInOverview', params.showInOverview);
  if (params.subCategories) {
    const subCategoriesJsonString = JSON.stringify(params.subCategories);
    bodyFormData.append('subCategories', subCategoriesJsonString);
  }
  if (params.pdf instanceof File) {
    bodyFormData.append('pdf', params.pdf);
  }
  if (params.cover instanceof File) {
    bodyFormData.append('image', params.cover);
  }
  return instance.post(apiPath.addChapter, bodyFormData).then((response) => response.data);
}

async function updateChapterAPI(params) {
  const bodyFormData = new FormData();
  bodyFormData.append('_id', params._id);
  // bodyFormData.append('parent', params.parent);
  bodyFormData.append('name', params.name || ' ');
  bodyFormData.append('subHeading', params.subHeading || ' ');
  bodyFormData.append('content', params.content || '');
  bodyFormData.append('subcategory', params.subCategory || '');
  bodyFormData.append('showInOverview', params.showInOverview);
  console.log("++++params.pdf", params.pdf)
  if (params.pdf instanceof File) {
    bodyFormData.append('pdf', params.pdf);
  }
  if (params.cover instanceof File) {
    bodyFormData.append('image', params.cover);
  }
  return instance.put(apiPath.updateChapter, bodyFormData).then((response) => response.data);
}

async function deleteChapterAPI(params) {
  return instance.delete(`${apiPath.deleteChapter}/${params._id}`).then((response) => response.data);
}

async function updateChapterStatusAPI(params) {
  return instance.patch(apiPath.updateChapterStatus, params).then((response) => response.data);
}

async function addStaticPageAPI(params) {
  const bodyFormData = new FormData();
  bodyFormData.append('title', params.title);
  bodyFormData.append('description', params.description);
  bodyFormData.append('content', params.content);
  bodyFormData.append('type', params.type);
  if (params.image.file) {
    bodyFormData.append('image', params.image.file);
  }
  return instance.post(apiPath.addStaticPage, bodyFormData).then((response) => response.data);
}

async function updateStaticPageAPI(params) {
  const bodyFormData = new FormData();
  bodyFormData.append('_id', params._id);
  bodyFormData.append('type', params.type);
  bodyFormData.append('title', params.title);
  if (params.image.file) {
    bodyFormData.append('image', params.image.file);
  }
  bodyFormData.append('description', params.description);
  bodyFormData.append('content', params.content);
  return instance.put(apiPath.updateStaticPage, bodyFormData).then((response) => response.data);
}

async function getStaticPagesAPI() {
  return instance.get(apiPath.getStaticPages).then((response) => response.data);
}

async function detailStaticPageAPI(params) {
  return instance.get(`${apiPath.detailStaticPage}/${params}`).then((response) => response.data);
}

const chapterService = {
  getChaptersAPI,
  addChapterAPI,
  updateChapterAPI,
  deleteChapterAPI,
  updateChapterStatusAPI,
  getStaticPagesAPI,
  addStaticPageAPI,
  updateStaticPageAPI,
  detailStaticPageAPI
};
export default chapterService;
